/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["#text[_ngcontent-%COMP%]{font-size:1.6rem!important;line-height:100%;margin-top:10px}h2[_ngcontent-%COMP%]{text-align:center;margin-bottom:15px}"];
export { styles as styles };
